import {Blog} from "../blog/blog-domain";
import {SeoService} from "./seo.service";
import {FirestoreStructuredData} from "./structured-data/firestore-structured-data";

export class BrowserSeoService extends SeoService {

  setTagsForHomepage(_firestoreStructuredData: FirestoreStructuredData): void {
  }

  setTagsForBlog(_firestoreStructuredData: FirestoreStructuredData, _posts: Blog.PostHeader[]): void {
  }

  setTagsForBlogPost(_firestoreStructuredData: FirestoreStructuredData, _postData: Blog.Post): void {
  }

  getFirestoreStructuredData(): Promise<FirestoreStructuredData> {
    return Promise.resolve({});
  }

}
